import React from "react";
import ProofInProjects from "../components/Offering/ProofInProjects";
import SolutionAccelerator from "../components/Offering/SolutionAccelerator";
import Solutions from "../components/Offering/Solutions";
import HeroSection from "../components/Offering/HeroSection";
 
const OfferingA = () => {
  return (
    <div className="relative w-full">
      <div className="flex flex-col justify-center items-center pb-[25px] max-w-screen overflow-hidden">
        <HeroSection>
          AI Agents, Purpose-Built for Your Stack and Your Usecase.
        </HeroSection>
        <Solutions />
 
        <SolutionAccelerator />
        <ProofInProjects />
      </div>
    </div>
  );
};
 
export default OfferingA;
